import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../web/src/components/interactive/button.jsx';
import { usePageTitle } from '../layout/use-page-title.js';

/**
 * 404 page for unknown routes inside a language section.
 * @returns {JSX.Element}
 */
export function NotFoundPage() {
	const { lang } = useParams();
	const { t } = useTranslation();
	usePageTitle('site.notFound.title', 'site.meta.notFound.description');

	return (
		<section className="page-not-found">
			<h1>{t('site.notFound.title')}</h1>
			<p>{t('site.notFound.body')}</p>
			<Button as="link" to={`/${lang}/`} variant="primary">{t('site.notFound.cta')}</Button>
		</section>
	);
}
